import {TaskQueue} from './taskQueues';

type TaskQueueMap = {[key: string]: TaskQueue<any> | undefined};
export const taskQueues: TaskQueueMap = {};

/** Hacky workaround to reset the task queues in a test environment. Will no-op otherwise. */
export function resetTaskQueuesInTest() {
  Object.keys(taskQueues).forEach((k) => {
    delete taskQueues[k];
  });
}
